'use client'

import { useEnableFull3d } from '@/hooks/useEnableFull3d'
import { useEffect } from 'react'

export const useFullscreenBodyStyle = () => {
  const enableFull3d = useEnableFull3d()

  useEffect(() => {
    if (enableFull3d) {
      document.body.style.overflow = 'hidden'
      document.body.style.overscrollBehaviorY = 'auto'

      return () => {
        document.body.style.overflow = ''
        document.body.style.overscrollBehaviorY = ''
      }
    }
  }, [enableFull3d])
}
